import FirebaseContext from './context';
import FirebaseInstance from './firebase';

export default FirebaseInstance;

export { FirebaseContext };
